document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('sizeChartModal');

  if (!modal) return;

  // --- Helper functions ---
  const fadeIn = (el, duration = 300) => {
    el.style.display = 'flex';
    el.style.opacity = 0;
    el.style.transition = `opacity ${duration}ms ease`;
    requestAnimationFrame(() => {
      el.style.opacity = 1;
    });
  };

  const fadeOut = (el, duration = 300) => {
    el.style.opacity = 1;
    el.style.transition = `opacity ${duration}ms ease`;
    el.style.opacity = 0;
    setTimeout(() => {
      el.style.display = 'none';
    }, duration);
  };

  // --- Event delegation for dynamic elements ---
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('.sizeChartBtn');
    const closeBtn = e.target.closest('.closeIcon');

    // Open modal
    if (openBtn) {
      e.preventDefault();
      fadeIn(modal, 250);
    }

    // Close modal
    if (closeBtn) {
      e.preventDefault();
      fadeOut(modal, 250);
    }

    // Click outside modal content closes it
    if (e.target === modal) {
      fadeOut(modal, 250);
    }
  });
});
